import React from "react";

const ScholarPaymentFailed = () => {
  return <div>ScholarPaymentFailed</div>;
};

export default ScholarPaymentFailed;
